import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import CampaignInfoBanner from '../CampaignInfoBanner/CampaignInfoBannerContainer.js';
import Header from '../Header/HeaderContainer.js';

const Layout = (_param)=> {
    var { children , className , hasNavigation =true , resetHtmlScrolling =false , banner  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "hasNavigation",
        "resetHtmlScrolling",
        "banner"
    ]);
    return React.createElement(React.Fragment, null, resetHtmlScrolling ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
            /* fixes scroll to top issue */
            html {
              overflow: auto;
            }
          `)) : null, /*#__PURE__*/ React.createElement("main", swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-layout', className)
    }), /*#__PURE__*/ React.createElement(Header, {
        hasNavigation: hasNavigation
    }), /*#__PURE__*/ React.createElement(CampaignInfoBanner, swcHelpers.extends({}, banner)), /*#__PURE__*/ React.createElement("div", {
        "data-t": "layout-container",
        className: classnames('book-appointment-layout__container', {
            'book-appointment-layout__container--without-navigation': !hasNavigation
        })
    }, children)));
};
var Layout$1 = Layout;

export { Layout$1 as default };
//# sourceMappingURL=Layout.js.map
